export const defaultOptions = { useCamelCaseFlagKeys: true };
